class QuantityCards extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {

  }

  disconnectedCallback() {

  }
}

export default QuantityCards